<template>
  <div v-if="total > 0" class="table-pager">
    <span>共 {{ total }} 条</span>
    <el-pagination
      background
      :current-page="page"
      :page-size="limit"
      :page-sizes="[10,20,50,100]"
      layout="sizes, prev, pager, next"
      :total="total"
      @current-change="$emit('page-change', $event)"
      @size-change="$emit('limit-change', $event)"
    />
  </div>
</template>
<script>
export default {
  name: "TablePager",
  props: { total: { type: Number, default: 0 }, page: { type: Number, default: 1 }, limit: { type: Number, default: 20 } }
}
</script>
